// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Decco from "../../../../../../../node_modules/decco/src/Decco.bs.js";
import * as Js_dict from "../../../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Js_json from "../../../../../../../node_modules/rescript/lib/es6/js_json.js";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Belt_Result from "../../../../../../../node_modules/rescript/lib/es6/belt_Result.js";

function orderLog_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var ts_millis = Decco.floatFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "ts_millis"), null));
  if (ts_millis.TAG === /* Ok */0) {
    var description = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "description"), null));
    if (description.TAG === /* Ok */0) {
      var admin = Decco.stringFromJson(Belt_Option.getWithDefault(Js_dict.get(dict$1, "admin"), null));
      if (admin.TAG === /* Ok */0) {
        return {
                TAG: /* Ok */0,
                _0: {
                  ts_millis: ts_millis._0,
                  description: description._0,
                  admin: admin._0
                }
              };
      }
      var e = admin._0;
      return {
              TAG: /* Error */1,
              _0: {
                path: ".admin" + e.path,
                message: e.message,
                value: e.value
              }
            };
    }
    var e$1 = description._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".description" + e$1.path,
              message: e$1.message,
              value: e$1.value
            }
          };
  }
  var e$2 = ts_millis._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".ts_millis" + e$2.path,
            message: e$2.message,
            value: e$2.value
          }
        };
}

function fromString(offset) {
  if (offset === "") {
    return ;
  } else {
    return offset;
  }
}

function toString(offset) {
  if (offset !== undefined) {
    return offset;
  } else {
    return "";
  }
}

function offset_decode(json) {
  return Belt_Result.map(Decco.stringFromJson(json), fromString);
}

function t_decode(v) {
  var dict = Js_json.classify(v);
  if (typeof dict === "number") {
    return Decco.error(undefined, "Not an object", v);
  }
  if (dict.TAG !== /* JSONObject */2) {
    return Decco.error(undefined, "Not an object", v);
  }
  var dict$1 = dict._0;
  var order_logs = Decco.listFromJson(orderLog_decode, Belt_Option.getWithDefault(Js_dict.get(dict$1, "order_logs"), null));
  if (order_logs.TAG === /* Ok */0) {
    var json = Belt_Option.getWithDefault(Js_dict.get(dict$1, "offset"), null);
    var offset = Belt_Result.map(Decco.stringFromJson(json), fromString);
    if (offset.TAG === /* Ok */0) {
      return {
              TAG: /* Ok */0,
              _0: {
                order_logs: order_logs._0,
                offset: offset._0
              }
            };
    }
    var e = offset._0;
    return {
            TAG: /* Error */1,
            _0: {
              path: ".offset" + e.path,
              message: e.message,
              value: e.value
            }
          };
  }
  var e$1 = order_logs._0;
  return {
          TAG: /* Error */1,
          _0: {
            path: ".order_logs" + e$1.path,
            message: e$1.message,
            value: e$1.value
          }
        };
}

export {
  orderLog_decode ,
  fromString ,
  toString ,
  offset_decode ,
  t_decode ,
  
}
/* No side effect */
